import axios from '@fs/zion-axios'
import { appPath } from '@fs/zion-config'

const splunkLogger = {
  /**
   * Log a message to remote with a severity level.
   * @param {string|object} data         - Information to log to remote.
   * @param {number}        [severity=1] - Severity level (log = 1, info = 2, warn = 3, error = 4)
   */

  log(data, severity = 1) {
    if (typeof data === 'object') {
      if (Object.keys(data).length < 1) {
        throw new TypeError('splunk-logger object data should not be empty')
      }
    } else {
      throw new TypeError('splunk-logger data should only be a string or object')
    }

    const logObj = {
      s: severity,
      m: data,
    }

    if (appPath) {
      const url = `${appPath}/splunk-logger`
      axios.post(url, logObj, { headers: { 'Content-type': 'application/json' } }).catch((err) => {
        console.error('Error sending to Splunk Logger:', err)
      })
    }
  },

  /**
   * @param {string|object} data - Information to log to remote.
   */
  info(data) {
    this.log(data, 2)
  },

  /**
   * Log a message with severity level 3.
   * @param {string|object} data - Information to log to remote.
   */
  warn(data) {
    this.log(data, 3)
  },

  /**
   * Log a message with severity level 4.
   * @param {string|object} data - Information to log to remote.
   */
  error(data) {
    this.log(data, 4)
  },
}

export default splunkLogger
